import { render, staticRenderFns } from "./emailresetverify.vue?vue&type=template&id=6fb0765e&scoped=true&"
import script from "./emailresetverify.vue?vue&type=script&lang=js&"
export * from "./emailresetverify.vue?vue&type=script&lang=js&"
import style0 from "./emailresetverify.vue?vue&type=style&index=0&id=6fb0765e&lang=scss&scoped=true&"
import style1 from "./emailresetverify.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0765e",
  null
  
)

export default component.exports